module.exports = "pegasus_template/assets/blocks/image-4-theme5.png";